/**
 * In-app disclosure required by Google for apps using restricted Google Health API scopes.
 * It must be shown during normal use, before the Google consent screen, and must say what
 * data is accessed and how it is used or shared. Keep this wording in sync with /privacy.
 */
export default function HealthDataDisclosure() {
  return (
    <div style={{
      background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: 8,
      padding: '12px 16px', marginBottom: 16, fontSize: 13, lineHeight: 1.6, color: '#334155',
    }}>
      <strong>How Jamasp uses your Google Health data.</strong> Jamasp collects your Fitbit
      activity, sleep, heart and health-metric data, and basic device information (model and last
      sync), through Google Health to link it with the surveys you complete in this study, to
      analyze how your physiology changes during the study, and to show you a summary of your own
      recent data after you connect. Your data are used only for the research
      you consent to; they are never sold or used for advertising, and you can withdraw at any time.{' '}
      <a href="/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#0A66C2' }}>
        Privacy Policy
      </a>
    </div>
  );
}
